import { render, staticRenderFns } from "./VideoLinks.vue?vue&type=template&id=626aa13a&scoped=true"
import script from "./VideoLinks.vue?vue&type=script&lang=js"
export * from "./VideoLinks.vue?vue&type=script&lang=js"
import style0 from "./VideoLinks.vue?vue&type=style&index=0&id=626aa13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626aa13a",
  null
  
)

export default component.exports